<template>
    <v-card class="px-4">
        <v-card-text class="pa-0 mt-3" style="height: 650px;">
            <v-layout row style="overflow-y: auto;">
                <v-flex xs6 column>
                    <v-card-title class="headline pt-1 pb-5 px-0"
                        >Payment</v-card-title
                    >
                    <v-text-field
                        class="mb-4"
                        type="number"
                        label="Amount"
                        ref="amount"
                        v-model="amount"
                        :rules="amountRules"
                        prefix="$"
                    ></v-text-field>
                    <v-select
                        class="mb-4"
                        :items="paymentTypes"
                        label="Payment Type"
                        v-model="type"
                        ref="paymentType"
                        hide-details
                    >
                    </v-select>
                    <div v-if="type == 'Credit Card'">
                        <v-layout column>
                            <v-select
                                v-if="paymentMethods.length"
                                class="mb-2"
                                clearable
                                :items="paymentMethods"
                                label="Cards On File"
                                v-model="selectedCard"
                                item-text="`${data.item.cardInfo}`"
                            >
                                <template slot="selection" slot-scope="data">
                                    {{ data.item.cardInfo }}
                                </template>
                                <template slot="item" slot-scope="data">
                                    <v-list-tile-content>
                                        <v-list-tile-title
                                            v-html="`${data.item.cardInfo}`"
                                        >
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                </template>
                            </v-select>
                            <div v-if="!selectedCard">
                                <v-text-field
                                    class=""
                                    label="Card Number"
                                    ref="cardNumber"
                                    :mask="creditCardMask"
                                    v-model="cardNumber"
                                    :rules="cardNumberRules"
                                    append-icon="mdi-credit-card"
                                ></v-text-field>
                                <v-layout row class="mb-2">
                                    <v-select
                                        class="mr-1 "
                                        ref="expirationMonth"
                                        :items="getMonthOptions()"
                                        label="Exp. Month"
                                        v-model="expirationMonth"
                                        :rules="expirationMonthRules"
                                    ></v-select>
                                    <v-select
                                        :items="getYearOptions()"
                                        ref="expirationYear"
                                        v-model="expirationYear"
                                        :rules="expirationYearRules"
                                        label="Exp. year"
                                    ></v-select>
                                </v-layout>
                                <v-layout row class="mb-4">
                                    <v-text-field
                                        style="margin-bottom: -27px"
                                        label="Security Code"
                                        ref="securityCode"
                                        v-model="securityCode"
                                        :rules="securityCodeRules"
                                        :mask="securityCodeMask"
                                    ></v-text-field>
                                    <div style="height: 48px">
                                        <img
                                            src="https://utaw.blob.core.windows.net/images/credit-card-cvc-all.svg"
                                            style="width: 77px;"
                                        />
                                        <img
                                            src="https://utaw.blob.core.windows.net/images/credit-card-cvc-amex.svg"
                                            style="width: 77px;"
                                        />
                                    </div>
                                </v-layout>
                                <v-checkbox
                                    class="mb-2"
                                    hide-details
                                    label="Save For Future"
                                    color="success"
                                    v-model="saveForFuture"
                                ></v-checkbox>
                            </div>
                        </v-layout>
                    </div>
                    <div>
                        <v-text-field
                            class="mb-2"
                            label="Check Number"
                            ref="checkNumber"
                            v-model="checkNumber"
                        ></v-text-field>

                        <v-menu
                            v-model="datePickerMenu"
                            :close-on-content-click="false"
                            full-width
                            max-width="290"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    :value="formatedDate"
                                    label="Date"
                                    readonly
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="date"
                                :min="today"
                                @change="datePickerMenu = false"
                            ></v-date-picker>
                        </v-menu>
                    </div>

                    <v-text-field
                        class="mb-2"
                        v-model="emailAddress"
                        :rules="emailRules"
                        label="Email"
                        ref="email"
                    ></v-text-field>

                    <v-text-field
                        class="mb-2"
                        label="Note"
                        ref="note"
                        v-model="notes"
                        :rules="noteRules"
                    ></v-text-field>

                    <v-text-field
                        class="mb-2"
                        label="Receipt"
                        v-model="receipt"
                    ></v-text-field>
                </v-flex>
                <v-divider vertical></v-divider>
                <v-flex xs6 column>
                    <schedule-payment
                        v-if="scheduledPayments.length"
                        :schedules="scheduledPayments"
                        :addSchedule="addSchedule"
                        :removeSchedule="removeSchedule"
                        :schedulesDiscrepancy="schedulesDiscrepancy"
                        :paymentType="type"
                    ></schedule-payment>
                </v-flex>
            </v-layout>
        </v-card-text>

        <v-card-actions class="mt-4 mr-0 pb-4">
            <v-spacer></v-spacer>
            <v-btn dark color="default" @click="closePaymentDialog">
                Close
            </v-btn>
            <v-btn
                :loading="processing"
                color="success"
                @click="processPayment"
            >
                Process Payment
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import moment from "moment";
import cardValidator from "card-validator";
import { loadOptions } from "../../../utils/smLookup.js";
import { getDomain, sum, toISOLocal } from "../../../utils/helpers.js";
import schedulePayment from "./SchedulePayment.vue";

export default {
    props: {
        paymentMethods: Array,
        closePaymentDialog: Function,
        account: Object,
        lapidusAccount: Object,
        refresh: Function,
    },
    components: {
        "schedule-payment": schedulePayment,
    },
    data() {
        return {
            type: "Credit Card",
            cardNumber: "",
            expirationMonth: "",
            expirationYear: "",
            securityCode: "",
            notes: "",
            date: toISOLocal(new Date()).substr(0, 10),
            datePickerMenu: false,
            status: "",
            selectedCard: "",
            nameOnCard: "",
            amount: "",
            processing: false,
            checkNumber: "",
            receipt: "",
            today: new Date().toISOString().substr(0, 10),
            emailAddress: "",

            paymentTypes: [],
            scheduledPayments: [],
            schedulesDiscrepancy: false,
            saveForFuture: true,

            amountRules: [
                (value) => !!value || "Amount Is Required",
                (value) => {
                    return (
                        this.type != "Credit Card" ||
                        !value ||
                        value > 0 ||
                        "Amount Can't Be Negative"
                    );
                },
            ],

            emailRules: [
                (value) => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return !value || pattern.test(value) || "Invalid e-mail.";
                },
            ],

            nameOnCardRules: [
                (v) => this.type != "Check" || !!v || "Name Is Required",
            ],

            noteRules: [
                (v) =>
                    !this.amount ||
                    this.amount > 0 ||
                    !!v ||
                    "Note Is Required",
            ],

            cardNumberRules: [
                (v) => this.selectedCard || !!v || "Card Number Is Required",
                (v) => (v && this.validateCard()) || "Invalid Card Number",
            ],
            expirationMonthRules: [
                (v) =>
                    this.selectedCard || !!v || "Expiration Month Is Required",
                (v) =>
                    (v && this.validateExpirationMonth()) ||
                    "Invalid Expiration Month",
            ],
            expirationYearRules: [
                (v) =>
                    this.selectedCard || !!v || "Expiration Year Is Required",
                (v) =>
                    (v && this.validateExpirationYear()) ||
                    "Invalid Expiration Year",
            ],
            securityCodeRules: [
                // (v) => this.selectedCard || !!v || "Security Code Is Required",
                (v) =>
                    !v ||
                    (v && this.validateSecurityCode()) ||
                    "Invalid Security Code",
            ],
        };
    },
    async created() {
        await this.loadPaymentTypes();

        this.scheduledPayments.push({
            date: this.date,
            amount: 0,
            datePickerMenu: false,
            checkNumber: "",
        });
    },
    computed: {
        formatedDate() {
            return this.date ? moment(this.date).format("L") : "";
        },
        creditCardMask() {
            const numberValidation = cardValidator.number(this.cardNumber);

            return numberValidation.card &&
                numberValidation.card.type == "american-express"
                ? "#### ###### #####"
                : "#### #### #### ####";
        },
        securityCodeMask() {
            const numberValidation = cardValidator.number(this.cardNumber);

            return numberValidation.card && numberValidation.card.code.size == 4
                ? "####"
                : "###";
        },
    },
    watch: {
        amount(newValue, oldValue) {
            if (!this.scheduledPayments.length) return;

            const scheduledPaymentsTotal = sum(
                this.scheduledPayments.slice(1).map((s) => +s.amount)
            );

            this.scheduledPayments[0].amount = Math.max(
                0,
                newValue - scheduledPaymentsTotal
            );
        },
        date(newValue, oldValue) {
            if (!this.scheduledPayments.length) return;

            this.scheduledPayments[0].date = this.date;
        },
        account(newValue, oldValue) {
            this.emailAddress = newValue.emailAddress;
        },
    },
    methods: {
        async loadPaymentTypes() {
            this.paymentTypes = (await loadOptions("paymentType")).map(
                (v) => v.value
            );
        },
        getMonthOptions() {
            const months = [
                { value: "01", text: "1 January" },
                { value: "02", text: "2 February" },
                { value: "03", text: "3 March" },
                { value: "04", text: "4 April" },
                { value: "05", text: "5 May" },
                { value: "06", text: "6 June" },
                { value: "07", text: "7 July" },
                { value: "08", text: "8 August" },
                { value: "09", text: "9 September" },
                { value: "10", text: "10 October" },
                { value: "11", text: "11 November" },
                { value: "12", text: "12 December" },
            ];

            if (this.expirationYear != moment().format("YY")) return months;

            const currentMonth = new Date().getMonth();

            return months.filter((month) => +month.value >= currentMonth + 1);
        },
        getYearOptions() {
            const currentYear = moment().year();
            const currentMonth = moment().month() + 1;
            const yearOptions = [];

            for (let i = 0; i < 10; i++) {
                const year = moment()
                    .add(i, "years")
                    .year();

                if (this.expirationMonth <= currentMonth && i == 0) continue;

                yearOptions.push({
                    text: year,
                    value: year.toString().slice(-2),
                });
            }
            return yearOptions;
        },
        validateCard() {
            const numberValidation = cardValidator.number(this.cardNumber);

            return numberValidation.isValid;
        },
        validateExpirationMonth() {
            return cardValidator.expirationMonth(this.expirationMonth).isValid;
        },
        validateExpirationYear() {
            return cardValidator.expirationYear(this.expirationYear).isValid;
        },
        validateSecurityCode() {
            const numberValidation = cardValidator.number(this.cardNumber);

            if (
                numberValidation &&
                numberValidation.card &&
                numberValidation.card.code
            ) {
                return cardValidator.cvv(
                    this.securityCode,
                    numberValidation.card.code.size
                ).isValid;
            }

            return cardValidator.cvv(this.securityCode).isValid;
        },

        validateScheduledPayments() {
            const scheduledPaymentsTotal = sum(
                this.scheduledPayments.map((s) => +s.amount)
            );

            const discrepancy = this.amount != scheduledPaymentsTotal;

            this.schedulesDiscrepancy = discrepancy;

            return !discrepancy;
        },
        validate() {
            const validations = [
                this.$refs.amount.validate(true),
                this.$refs.email.validate(true),
                this.$refs.note.validate(true),
            ];

            if (this.type == "Credit Card") {
                validations.push(this.validateScheduledPayments());

                if (!this.selectedCard) {
                    validations.push(this.$refs.cardNumber.validate(true));
                    validations.push(this.$refs.expirationMonth.validate(true));
                    validations.push(this.$refs.expirationYear.validate(true));
                    validations.push(this.$refs.securityCode.validate(true));
                }
            }

            if (this.type == "Check") {
                validations.push(this.validateScheduledPayments());
            }

            return validations.every(Boolean);
        },
        addSchedule() {
            this.scheduledPayments.push({
                date: toISOLocal(new Date()).substr(0, 10),
                amount: 0,
                datePickerMenu: false,
                checkNumber: "",
            });
        },
        removeSchedule(index) {
            this.scheduledPayments.splice(index, 1);
        },
        isScheduledPayment(schedule) {
            return !this.isToday(schedule.date);
        },
        isToday(date) {
            return moment(date).isSame(new Date(), "day");
        },
        getPaymentType(type) {
            if (type == "Credit Card") return "CC";

            return type;
        },
        getPaymentData() {
            const payments = this.scheduledPayments.filter((s) => s.amount > 0);

            const currentPaymentAmount =
                this.type == "Credit Card"
                    ? sum(
                          payments
                              .filter((s) => {
                                  return this.isToday(s.date);
                              })
                              .map((schedule) => +schedule.amount)
                      )
                    : +this.amount;

            return {
                receipt: this.receipt,
                user: this.$store.state.authentication.user,
                checkNumber: this.checkNumber,
                checks:
                    this.type == "Check"
                        ? payments.map((payment, index) => {
                              if (!payment.checkNumber && index == 0) {
                                  payment.checkNumber = this.checkNumber;
                              }

                              return payment;
                          })
                        : null,
                payment: {
                    isTestPayment: window.location.origin.startsWith(
                        "http://localhost"
                    ),
                    paymentMethodID:
                        this.type == "Credit Card" && this.selectedCard
                            ? this.selectedCard.id
                            : null,
                    accountID: this.account.accountID,
                    billingName: this.account.name,
                    //nameOnCard: this.account.name, //payment.nameOnCard,
                    departmentId: 43,
                    emailAddressArray: this.emailAddress
                        ? [this.emailAddress]
                        : ["no-reply@utaw.org"],
                    paymentCategories:
                        currentPaymentAmount > 0
                            ? [
                                  {
                                      categoryCode: "GIRC",
                                      amount: currentPaymentAmount,
                                  },
                              ]
                            : null,
                    paymentDate: moment(this.date).format(
                        "YYYY-MM-DD HH:mm:ss"
                    ),
                    paymentType: this.getPaymentType(this.type),
                    saveForFuture: this.saveForFuture,
                    x_Amount: currentPaymentAmount || null,
                    x_exp_date: this.expirationMonth + this.expirationYear,
                    x_Card_Num: this.cardNumber,
                    x_CVV_Code: this.securityCode,
                    notes: this.notes,
                    schedule: payments.filter(this.isScheduledPayment).length
                        ? {
                              recurrenceCount: payments.filter(
                                  this.isScheduledPayment
                              ).length,
                              recurrenceType: "custom",
                              scheduledTransectionDetails: payments
                                  .filter(this.isScheduledPayment)
                                  .map((schedule) => ({
                                      scheduleDate: schedule.date,
                                      amount: schedule.amount,
                                      paymentCategories: [
                                          {
                                              categoryCode: "GIRC",
                                              amount: +schedule.amount,
                                          },
                                      ],
                                  })),
                          }
                        : null,
                },
            };
        },
        async processPayment() {
            if (!this.validate()) return;

            this.processing = true;

            const paymentData = this.getPaymentData();

            try {
                await this.$http.post(
                    "api/girlsCamp/processPayment?accountID=" +
                        this.account.accountID,
                    paymentData
                );
            } catch (e) {
                this.processing = false;

                return;
            }

            this.processing = false;

            this.$notify({
                text: "Payment Saved",
                group: "notification",
                type: "success",
            });

            this.clear();

            this.closePaymentDialog();

            this.refresh();
        },
        clear() {
            this.cardNumber = "";
            this.expirationMonth = "";
            this.expirationYear = "";
            this.securityCode = "";
            this.notes = "";
            this.status = "";
            this.selectedCard = "";
            this.nameOnCard = "";
            this.amount = "";
            this.checkNumber = "";
            this.receipt = "";
            this.date = toISOLocal(new Date()).substr(0, 10);

            this.scheduledPayments = [
                {
                    date: this.date,
                    amount: 0,
                    datePickerMenu: false,
                    checkNumber: "",
                },
            ];

            this.schedulesDiscrepancy = false;

            if (this.type == "Credit Card" && this.$refs.cardNumber) {
                this.$refs.cardNumber.resetValidation();
                this.$refs.expirationMonth.resetValidation();
                this.$refs.expirationYear.resetValidation();
                this.$refs.securityCode.resetValidation();
            }

            this.$refs.amount.resetValidation();

            this.type = "Credit Card";
        },
        getData() {
            return this;
        },
    },
};
</script>
<style>
.scroll-container {
    height: 100%;
    overflow-y: scroll;
    backface-visibility: hidden;
}
</style>
